exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group {\n\tmargin:0;\n}\n.m-t-20 {\n\tmargin-top:20px;\n}\n.modal-bg {\n    border: 1px solid #ddd;\n    background: #fff;\n    width: 100%;\n    max-width: 420px;\n    margin: 30px auto;\n\tfont-size: 14px;\n}\n.unexpected-grp {\n    background: #f1ed6d;\n    padding: 10px 15px;\n}\n.unexpected-grp p {\n    margin: 0;\n}\n.modal-text {\n    padding: 15px;\n}\n.pop-btn button.btn {\n    width: 50%;\n    padding: 8px;\n    font-size: 14px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/reset/reset.component.css
// module id = ../../../../../src/app/event/reset/reset.component.css
// module chunks = main